// extracted by mini-css-extract-plugin
module.exports =  {"filter":"ABvglcZ7Sv4hNjmwtExc"};